import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import { Checkbox, CircularProgress } from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

import { ThemedTrashIcon } from "assets/CXFIcons/Triggers";
import { ThemedXIcon } from "assets/CXFIcons/Static";

import {
  setDeleteFlowVersionDialogOpen,
  setFlowVersionToDelete
} from "redux/actions/flowDesigner/flowsActionCreator";
import useFlowVersions from "hooks/useFlowVersions";

const DeleteFlowVersionDialog = () => {
  const { flowVersionToDelete, deleteFlowVersionDialogOpen } = useSelector(
    (state) => state.designer.flows
  );
  const { deleteFlowVersionById } = useFlowVersions(null, false);
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteVersion, setDeleteVersion] = useState(false);

  const handleCloseDeleteFlowDialog = () => {
    dispatch(setDeleteFlowVersionDialogOpen(false));
  };

  const handleDeleteFlowVersion = async () => {
    if (flowVersionToDelete) {
      setIsDeleting(true);
      await deleteFlowVersionById(flowVersionToDelete.flow_id, flowVersionToDelete.version);
      setIsDeleting(false);
    }
    handleCloseDeleteFlowDialog();
    setDeleteVersion(false);
    dispatch(setFlowVersionToDelete(null));
  };

  return (
    <Dialog
      open={deleteFlowVersionDialogOpen}
      onClose={handleCloseDeleteFlowDialog}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle
        sx={{
          marginBottom: "20px",
          padding: "32px 24px 0 24px !important",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        className="white-to-dark"
        data-testid="form-title"
      >
        <SoftBox display="flex" alignItems="center">
          <ThemedTrashIcon sx={{ fontSize: "16px !important", marginRight: "16px" }} />
          Trash
        </SoftBox>
        <IconButton onClick={handleCloseDeleteFlowDialog}>
          <ThemedXIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "0 32px 24px"
        }}
      >
        <SoftBox className="border-top" sx={{ paddingTop: "24px" }}>
          <SoftTypography
            color="text"
            sx={{
              fontSize: "14px",
              marginBottom: "16px"
            }}
          >
            Are you sure you want to delete version?
          </SoftTypography>
          <SoftBox>
            <Checkbox
              id="confirmDelete"
              style={{
                marginRight: "20px"
              }}
              checked={deleteVersion}
              onChange={(event) => {
                setDeleteVersion(event.target.checked);
              }}
            />
            <SoftTypography
              component="label"
              htmlFor="confirmDelete"
              sx={{
                fontSize: "12px"
              }}
            >
              Yes, I am sure
            </SoftTypography>
          </SoftBox>
          <SoftBox>
            <SoftButton
              sx={{ backgroundColor: "#E53E3E !important", width: "100%", marginTop: "20px" }}
              color="error"
              onClick={() => {
                handleDeleteFlowVersion();
              }}
              disabled={!deleteVersion || isDeleting}
            >
              {isDeleting ? (
                <CircularProgress
                  size={24}
                  sx={{
                    color: "#fff",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                    zIndex: 1
                  }}
                />
              ) : (
                "delete"
              )}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteFlowVersionDialog;
